import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useReadingLogsStore from 'graph/state/query-hooks/use-reading-logs-store';
import { AppRoutes } from 'types';
import AssignmentCover from './AssignmentCover';
import { ASSIGNMENT_STATUSES, AssignmentWithCover } from '../types';
import { getAssignmentLetterBookCompletionStatus } from '../util';

type AssignmentLetterBookProps = {
  assignment: AssignmentWithCover;
};

const AssignmentLetterBook: React.FC<AssignmentLetterBookProps> = ({ assignment }) => {
  const [{ logs, isLoading, error }] = useReadingLogsStore(assignment.cover.id);
  const [letterBookStatus, setLetterBookStatus] = useState<ASSIGNMENT_STATUSES>(
    ASSIGNMENT_STATUSES.INCOMPLETE
  );

  useEffect(() => {
    if (logs && logs.length && !isLoading && !error) {
      setLetterBookStatus(getAssignmentLetterBookCompletionStatus(logs));
    }
  }, [logs, isLoading, error]);

  return (
    <Link
      to={{
        pathname: `/${AppRoutes.READ_BOOK}/${assignment?.cover?.routeParam}`,
      }}
      state={{ from: location.pathname }}
    >
      <AssignmentCover
        assignment={assignment as AssignmentWithCover}
        showLetterBookBadge={false}
        status={letterBookStatus}
      />
    </Link>
  );
};

export default AssignmentLetterBook;
